import SportsDeltaComponent from "./../components/SportsDelta/sportsDashboard";
import { connect } from "react-redux";
import { vehicleAction } from "./../store/actions";

const mapStateToProps = state => {
  const {
    vehicleReducer: {
        getSportsDeltaSuccess,
        getSportsDeltaError,
        getSportsDeltaLoader
    }
  } = state;
  return {
    getSportsDeltaSuccess,
    getSportsDeltaError,
    getSportsDeltaLoader
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSportsData: param =>
      dispatch(vehicleAction.getSportsData(param))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SportsDeltaComponent);